import { app_config } from "../config/app.config";
import toast from "react-hot-toast";

const errorMessageFormat = (message) => {
  if (!message) return "";
  let words = message.split("_");
  words = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  let formattedMessage = words.join(" ");
  return formattedMessage;
};

export const toastSuccessMessage = (message) => {
  toast.success(errorMessageFormat(message), app_config.toast_config);
};

export const toastErrorMessage = (message) => {
  toast.error(errorMessageFormat(message), app_config.toast_config);
};